'use strict';

var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
require('react');
var Tippy = require('@tippyjs/react/headless');
var tippy_js = require('tippy.js');
var parseDataAttributes = require('./parseDataAttributes-81c8dbee.js');
var _taggedTemplateLiteral = require('@babel/runtime/helpers/taggedTemplateLiteral');
var styled = require('@emotion/styled');
var Arrow = require('./Arrow-86d218a7.js');
var react = require('@emotion/react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var Tippy__default = /*#__PURE__*/_interopDefaultLegacy(Tippy);
var _taggedTemplateLiteral__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteral);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject, _templateObject2;
var TooltipStyled = styled__default["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral__default["default"](["\n    --bgColor: ", ";\n\n    background-color: var(--bgColor);\n    border-radius: ", ";\n    color: white;\n    font-size: ", ";\n    max-width: 228px;\n    padding: ", " ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors['background-brand-primary'];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.radii.medium;
}, function (_ref3) {
  var theme = _ref3.theme,
    fontSize = _ref3.fontSize;
  return fontSize === 'normal' ? theme.fontSizes.ln1 : theme.fontSizes.ln2;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space['8'];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.space['16'];
});
var StyledArrow = styled__default["default"](Arrow.Arrow)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral__default["default"](["\n    /* Reuse --bgColor from TooltipStyled above to set Arrow color */\n    --arrowColor: var(--bgColor);\n"])));

var _excluded = ["children", "innerRef"],
  _excluded2 = ["disabled", "content", "showOnCreate", "trigger", "placement", "children", "visible", "hideOnClick", "onClickOutside", "onShow", "onHide", "fontSize", "className", "followCursor", "touch", "verticalOffset", "horizontalOffset", "offset", "zIndex", "dataAttributes", "innerRef"];
var ContentWrapper = function ContentWrapper(_ref) {
  var children = _ref.children,
    innerRef = _ref.innerRef,
    restProps = _objectWithoutProperties__default["default"](_ref, _excluded);
  return react.jsx(TooltipStyled, _extends__default["default"]({
    ref: innerRef,
    tabIndex: -1
  }, restProps), children);
};
var omitParams = function omitParams(fn) {
  return function (instance) {
    return fn();
  };
};
var Tooltip = function Tooltip(_ref2) {
  var disabled = _ref2.disabled,
    content = _ref2.content,
    showOnCreate = _ref2.showOnCreate,
    _ref2$trigger = _ref2.trigger,
    trigger = _ref2$trigger === void 0 ? 'click' : _ref2$trigger,
    _ref2$placement = _ref2.placement,
    placement = _ref2$placement === void 0 ? 'auto' : _ref2$placement,
    children = _ref2.children,
    visible = _ref2.visible,
    _ref2$hideOnClick = _ref2.hideOnClick,
    hideOnClick = _ref2$hideOnClick === void 0 ? true : _ref2$hideOnClick,
    _ref2$onClickOutside = _ref2.onClickOutside,
    onClickOutside = _ref2$onClickOutside === void 0 ? function () {} : _ref2$onClickOutside,
    _ref2$onShow = _ref2.onShow,
    onShow = _ref2$onShow === void 0 ? function () {} : _ref2$onShow,
    _ref2$onHide = _ref2.onHide,
    onHide = _ref2$onHide === void 0 ? function () {} : _ref2$onHide,
    _ref2$fontSize = _ref2.fontSize,
    fontSize = _ref2$fontSize === void 0 ? 'normal' : _ref2$fontSize,
    className = _ref2.className,
    followCursor = _ref2.followCursor,
    _ref2$touch = _ref2.touch,
    touch = _ref2$touch === void 0 ? true : _ref2$touch,
    _ref2$verticalOffset = _ref2.verticalOffset,
    verticalOffset = _ref2$verticalOffset === void 0 ? 20 : _ref2$verticalOffset,
    _ref2$horizontalOffse = _ref2.horizontalOffset,
    horizontalOffset = _ref2$horizontalOffse === void 0 ? 10 : _ref2$horizontalOffse,
    offset = _ref2.offset,
    zIndex = _ref2.zIndex,
    _ref2$dataAttributes = _ref2.dataAttributes,
    dataAttributes = _ref2$dataAttributes === void 0 ? {} : _ref2$dataAttributes,
    innerRef = _ref2.innerRef,
    nativeProps = _objectWithoutProperties__default["default"](_ref2, _excluded2);
  var filterVisibilityProps = function filterVisibilityProps() {
    return visible !== undefined ? {
      visible: visible
    } : {
      visible: visible,
      trigger: trigger,
      hideOnClick: hideOnClick
    };
  };
  var calculateOffset = function calculateOffset(_ref3) {
    var placement = _ref3.placement;
    if (offset) {
      return offset;
    }
    if (placement.startsWith('bottom') || placement.startsWith('top')) {
      return [0, verticalOffset];
    }
    if (placement.startsWith('left') || placement.startsWith('right')) {
      return [0, horizontalOffset];
    }
    return [0, 0];
  };
  return react.jsx(Tippy__default["default"], {
    offset: calculateOffset,
    touch: touch,
    visible: filterVisibilityProps().visible,
    trigger: filterVisibilityProps().trigger,
    hideOnClick: filterVisibilityProps().hideOnClick,
    onShow: omitParams(onShow),
    onHide: omitParams(onHide),
    onClickOutside: omitParams(onClickOutside),
    disabled: disabled,
    placement: placement,
    followCursor: followCursor,
    plugins: [tippy_js.followCursor],
    showOnCreate: showOnCreate,
    zIndex: zIndex,
    render: function render(contentProps) {
      return react.jsx(ContentWrapper, _extends__default["default"]({}, nativeProps, parseDataAttributes.parseDataAttributes(dataAttributes), {
        innerRef: innerRef,
        className: className,
        fontSize: fontSize
      }, contentProps), content, react.jsx(StyledArrow, {
        placement: contentProps['data-placement'],
        isPopoverArrow: true
      }));
    }
  }, react.jsx("div", null, children));
};

exports.Tooltip = Tooltip;
//# sourceMappingURL=Tooltip-f7b87a80.js.map
